var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarCircle2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94922 13.136C7.94922 14.3185 8.85672 15.2718 9.98422 15.2718H12.2851C13.2659 15.2718 14.0634 14.4377 14.0634 13.411C14.0634 12.2927 13.5776 11.8985 12.8534 11.6418L9.15922 10.3585C8.43505 10.1018 7.94922 9.70768 7.94922 8.58935C7.94922 7.56268 8.74672 6.72852 9.72755 6.72852H12.0284C13.1559 6.72852 14.0634 7.68185 14.0634 8.86435",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.5V16.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 20.1673C16.0623 20.1673 20.1663 16.0633 20.1663 11.0007C20.1663 5.93804 16.0623 1.83398 10.9997 1.83398C5.93706 1.83398 1.83301 5.93804 1.83301 11.0007C1.83301 16.0633 5.93706 20.1673 10.9997 20.1673Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarCircle2);
export default __webpack_public_path__ + "static/media/dollar-circle 2.3e03e37c81b90dc400ac8a543f1e8e01.svg";
export { ForwardRef as ReactComponent };